import { IInvoiceRecipient } from 'shared/models/Deal';
import { createRequestActions, RequestType } from 'store/utils';

import {
    IGetInvoiceRecipientsPayload,
} from 'modules/settings/submodules/clients/deals/components/DealForm/components/InvoiceRecipientSelect/store/models';

export const getInvoiceRecipients = createRequestActions<IGetInvoiceRecipientsPayload, IInvoiceRecipient[]>(
    RequestType.Get,
    'INVOICE_RECIPIENTS');
